import styles from './Spinner.module.scss';

const Spinner = () => {
    return (
        <div className={styles.ldFacebook}><div></div><div></div><div></div></div>
    )
};

export default Spinner;
